import { render, staticRenderFns } from "./TransfersTable.vue?vue&type=template&id=3645c4cb"
import script from "./TransfersTable.vue?vue&type=script&lang=js"
export * from "./TransfersTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports